import { ResourceOptions } from 'react-admin';
import { MdOutlineTune } from 'react-icons/md';

import { Resources } from '../../resource';

export { default as list } from './List';
export { VAULT_PARAMS_PERMISSION_RESOURCE } from './constants';

export const name = Resources.vaultParams;
export const icon = MdOutlineTune;
export const options: ResourceOptions = {
  label: 'module.vaultParams.title',
};
